import React from 'react';
import './styles.css';

const AppFooter = React.memo(() => (
    <div className='divAppFooter'>
        <span>BB Seguros © {new Date().getFullYear()} Todos os direitos reservados</span>
    </div>
));

export default AppFooter;
